// Styles for SuperHero heading and H1 to H3
import { FONT_FAMILY_SUPER_HEADING } from '../../constants';
export const largeHeadingStyle = `
  font-family: ${FONT_FAMILY_SUPER_HEADING};
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;  
  letter-spacing: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;